<template>
    <div>
        <!-- Success Alert -->
        <div
            v-if="mailsent && current_id != 0"
            class="alert alert-success alert-dismissible fade show"
            role="alert"
        >
            <span v-if="mailsent == 1">Password e-mail sent.</span>
            <span v-else-if="mailsent == 2">Welcome e-mail sent.</span>
            <button
                type="button"
                class="btn-close"
                @click="mailsent = 0"
                aria-label="Close"
            ></button>
        </div>

        <div class="d-flex align-items-center mb-3">
            <button class="btn btn-outline-primary" @click.prevent="backtolist">
                &lt; Return to list
            </button>
            <h3 v-if="consultant_id > 0" class="mb-0 ms-4">
                {{ consultant_id }}
                <span :class="`${anon ? 'g-anon' : ''}`"
                    >{{ first_name }} {{ family_name }}</span
                >
            </h3>
            <h3 v-if="consultant_id < 0" class="mb-0 ms-4">Add User</h3>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs col-12 px-0 mx-0 mt-2" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link active"
                    id="general-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#general"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">General Information</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="features-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#features"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Features</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="surveys-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#surveys"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Surveys</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="invoices-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#invoices"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Invoices</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="certifications-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#certifications"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Certifications</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="events-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#events"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Events</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="courses-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#courses"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Courses</div>
                </button>
            </li>
            <li v-if="consultant_id > 0" class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="virtualbadges-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#virtualbadges"
                    type="button"
                    role="tab"
                >
                    <div class="col-12 text-center">Virtual Badges</div>
                </button>
            </li>

        </ul>

        <div class="tab-content mt-3">
            <!-- General Information Tab -->
            <div class="tab-pane fade show active" id="general" role="tabpanel">
                <div class="card border-0">
                    <div class="card-body">
                        <form autocomplete="off" @submit.stop.prevent>
                            <div class="row">
                                <!-- Left Column -->
                                <div class="col-6">
                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >First name</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="[
                                                    anon ? 'g-anon' : '',
                                                    first_name_valid === false
                                                        ? 'is-invalid'
                                                        : '',
                                                ]"
                                                id="first_name"
                                                v-model="first_name"
                                                @change="
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'first_name',
                                                        first_name,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                            <div
                                                v-if="
                                                    first_name_valid === false
                                                "
                                                class="invalid-feedback"
                                            >
                                                First name cannot be blank
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Family name</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="[
                                                    anon ? 'g-anon' : '',
                                                    family_name_valid === false
                                                        ? 'is-invalid'
                                                        : '',
                                                ]"
                                                id="family_name"
                                                v-model="family_name"
                                                @change="
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'family_name',
                                                        family_name,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                            <div
                                                v-if="
                                                    family_name_valid === false
                                                "
                                                class="invalid-feedback"
                                            >
                                                Family name cannot be blank
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Title</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="prefix_title"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'prefix_title',
                                                        prefix_title,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Company name</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="company_name"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'company_name',
                                                        company_name,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Address line 1</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="address_1"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'address_1',
                                                        address_1,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Address line 2</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="address_2"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'address_2',
                                                        address_2,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Zip code</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="zip_code"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'zip_code',
                                                        zip_code,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >City</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="city"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'city',
                                                        city,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >E-mail</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="[
                                                    anon ? 'g-anon' : '',
                                                    email_valid === false
                                                        ? 'is-invalid'
                                                        : '',
                                                ]"
                                                id="email"
                                                v-model="email"
                                                @change="
                                                    checkemail();
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'email',
                                                        email,
                                                    );
                                                "
                                                autocomplete="off"
                                            />
                                            <div
                                                v-if="email_valid === false"
                                                class="invalid-feedback"
                                            >
                                                {{ emailinvalidfeedback }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Telephone</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="telephone"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'telephone',
                                                        telephone,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Country</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                :class="
                                                    country_id_valid === false
                                                        ? 'is-invalid'
                                                        : ''
                                                "
                                                v-model="country_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'country_id',
                                                        country_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="country in countries"
                                                    :key="country.value"
                                                    :value="country.value"
                                                >
                                                    {{ country.text }}
                                                </option>
                                            </select>
                                            <div
                                                v-if="
                                                    country_id_valid === false
                                                "
                                                class="invalid-feedback"
                                            >
                                                You must select a country
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >URL</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="url"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'url',
                                                        url,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Affiliated Company</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                :class="
                                                    company_id_valid === false
                                                        ? 'is-invalid'
                                                        : ''
                                                "
                                                v-model="company_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'company_id',
                                                        company_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="company in companies"
                                                    :key="company.value"
                                                    :value="company.value"
                                                >
                                                    {{ company.text }}
                                                </option>
                                            </select>
                                            <div
                                                v-if="
                                                    company_id_valid === false
                                                "
                                                class="invalid-feedback"
                                            >
                                                You must select a company
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >VAT Number</label
                                        >
                                        <div style="width: 67%">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="vat_number"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'vat_number',
                                                        vat_number,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Consultant group</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="consultantgroup_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'consultantgroup_id',
                                                        consultantgroup_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="group in consultantgroups"
                                                    :key="group.value"
                                                    :value="group.value"
                                                >
                                                    {{ group.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Partner</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                :class="
                                                    partner_id_valid === false
                                                        ? 'is-invalid'
                                                        : ''
                                                "
                                                v-model="partner_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'partner_id',
                                                        partner_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="partner in partners"
                                                    :key="partner.value"
                                                    :value="partner.value"
                                                >
                                                    {{ partner.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Enterprise</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                v-model="enterprise_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'enterprise_id',
                                                        enterprise_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="e in enterprises"
                                                    :key="e.value"
                                                    :value="e.value"
                                                >
                                                    {{ e.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Consultant status</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select"
                                                v-model="consultantstatus_id"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'consultantstatus_id',
                                                        consultantstatus_id,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="status in consultantstatuses"
                                                    :key="status.value"
                                                    :value="status.value"
                                                >
                                                    {{ status.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Certified by</label
                                        >
                                        <div style="width: 67%">
                                            <select
                                                class="form-select col-7"
                                                v-model="certified_by"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'certified_by',
                                                        certified_by,
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="tot in tots"
                                                    :key="tot.value"
                                                    :value="tot.value"
                                                >
                                                    {{ tot.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Certification date</label
                                        >
                                        <div style="width: 67%">
                                            <datetime
                                                class="col-4 ms-0 ps-0 pe-0 me-0"
                                                type="date"
                                                input-class="form-control col-9 gdq-w-150px"
                                                @input="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'certification_date',
                                                        certification_date,
                                                    )
                                                "
                                                format="yyyy-LL-dd"
                                                v-model="certification_date"
                                                :phrases="{
                                                    ok: 'OK',
                                                    cancel: 'Cancel',
                                                }"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-start">
                                        <label
                                            class="col-form-label"
                                            style="width: 33%; flex-shrink: 0"
                                            >Diploma Number</label
                                        >
                                        <div
                                            class="text-start"
                                            style="width: 67%"
                                        >
                                            <input
                                                type="text"
                                                class="form-control col-7"
                                                v-model="certificate_number"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'certificate_number',
                                                        certificate_number,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                            <button
                                                v-if="
                                                    consultant_id != -1 &&
                                                    !certificate_number
                                                "
                                                class="btn btn-secondary mt-2"
                                                @click.prevent="
                                                    generate_certificate_number
                                                "
                                            >
                                                Generate
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right Column -->
                                <div class="col-6">
                                    <div class="mb-3 d-flex align-items-start">
                                        <label
                                            class="col-form-label"
                                            style="
                                                width: 42%;
                                                flex-shrink: 0;
                                                padding-top: calc(
                                                    0.375rem + 1px
                                                );
                                            "
                                            >User name</label
                                        >
                                        <div style="width: 58%">
                                            <input
                                                type="text"
                                                class="form-control mb-2"
                                                :class="anon ? 'g-anon' : ''"
                                                v-model="i_name"
                                                @change="
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'i_name',
                                                        i_name,
                                                    )
                                                "
                                                autocomplete="off"
                                            />
                                            <div
                                                v-if="consultant_id > 0"
                                                class="d-flex flex-wrap align-items-center gap-2 mt-2"
                                            >
                                                <button
                                                    class="btn btn-secondary"
                                                    @click.prevent="
                                                        setpassword(true)
                                                    "
                                                >
                                                    <span
                                                        class="icon-key me-2"
                                                    ></span
                                                    >Set password
                                                </button>
                                                <button
                                                    class="btn btn-outline-primary"
                                                    @click.prevent="
                                                        sendpasswordlink
                                                    "
                                                >
                                                    <span
                                                        class="icon-mail me-2"
                                                    ></span
                                                    >Send password link
                                                </button>
                                                <button
                                                    class="btn btn-outline-primary"
                                                    @click.prevent="
                                                        sendwelcomeemail
                                                    "
                                                >
                                                    <span
                                                        class="icon-mail me-2"
                                                    ></span
                                                    >Send welcome e-mail
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="
                                            settingpassword == true ||
                                            consultant_id < 0
                                        "
                                        class="mb-3 d-flex align-items-start"
                                    >
                                        <label
                                            class="col-form-label"
                                            style="
                                                width: 42%;
                                                flex-shrink: 0;
                                                padding-top: calc(
                                                    0.375rem + 1px
                                                );
                                            "
                                            >Password</label
                                        >
                                        <div style="width: 58%">
                                            <input
                                                type="text"
                                                style="display: none"
                                            />
                                            <input
                                                type="text"
                                                class="form-control gdq-w-200px"
                                                v-model="newpassword"
                                                autocomplete="off"
                                            />
                                            <button
                                                v-if="consultant_id > 0"
                                                class="btn btn-primary me-2 mt-2"
                                                @click.prevent="savepassword()"
                                            >
                                                <span
                                                    class="icon-checkmark"
                                                ></span>
                                            </button>
                                            <button
                                                v-if="consultant_id > 0"
                                                class="btn btn-danger mt-2"
                                                @click.prevent="
                                                    setpassword(false)
                                                "
                                            >
                                                <span class="icon-cross"></span>
                                            </button>
                                        </div>
                                    </div>



                                    <div class="mb-3 d-flex align-items-start">
                                        <label
                                            class="col-form-label"
                                            style="
                                                width: 42%;
                                                flex-shrink: 0;
                                                padding-top: 0;
                                            "
                                            >Last activity</label
                                        >
                                        <div style="width: 58%">
                                            <div
                                                class="form-check text-start"
                                                style="padding-left: 0"
                                            >
                                                {{
                                                    last_login
                                                        ? `Login: ${last_login.substring(0, 10)}`
                                                        : certification_date
                                                          ? `Certified: ${certification_date.substring(0, 10)}`
                                                          : ""
                                                }}
                                                <span
                                                    v-if="gdq_recertification"
                                                    class="badge bg-danger ms-2"
                                                    >Re-certify</span
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-start">
                                        <label
                                            class="col-form-label"
                                            style="
                                                width: 42%;
                                                flex-shrink: 0;
                                                padding-top: 0;
                                            "
                                            >User Groups</label
                                        >
                                        <div style="width: 58%">
                                            <div
                                                v-for="usergroup in usergroups"
                                                :key="usergroup.id"
                                                class="form-check text-start"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    :id="`usergroup_${usergroup.id}`"
                                                    :value="usergroup.id"
                                                    v-model="i_usergroups"
                                                    @change="saveusergroups"
                                                />
                                                <label
                                                    class="form-check-label"
                                                    :for="`usergroup_${usergroup.id}`"
                                                    >{{ usergroup.name }}</label
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Is a Spotify Consultant</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="spotify"
                                                    :true-value="1"
                                                    :false-value="0"
                                                    @change="
                                                        savefield(
                                                            'g_profile',
                                                            consultant_id,
                                                            'spotify',
                                                            spotify,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Anonymize surveys when close</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="
                                                        anonymize_survey_on_close
                                                    "
                                                    :true-value="1"
                                                    :false-value="0"
                                                    @change="
                                                        savefield(
                                                            'g_profile',
                                                            consultant_id,
                                                            'anonymize_survey_on_close',
                                                            anonymize_survey_on_close,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Subscribes to Newsletter</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="newsletter"
                                                    :true-value="1"
                                                    :false-value="0"
                                                    @change="
                                                        savefield(
                                                            'g_profile',
                                                            consultant_id,
                                                            'newsletter',
                                                            newsletter,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Subscribes to General
                                            e-mails</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="general_emails"
                                                    :true-value="1"
                                                    :false-value="0"
                                                    @change="
                                                        savefield(
                                                            'g_profile',
                                                            consultant_id,
                                                            'general_emails',
                                                            general_emails,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Subscribes to Priority
                                            e-mails</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="priority_emails"
                                                    :true-value="1"
                                                    :false-value="0"
                                                    @change="
                                                        savefield(
                                                            'g_profile',
                                                            consultant_id,
                                                            'priority_emails',
                                                            priority_emails,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="consultant_id < 1"
                                        class="mb-3 d-flex align-items-center"
                                    >
                                        <label
                                            class="col-form-label"
                                            style="width: 42%; flex-shrink: 0"
                                            >Send 'set password' e-mail</label
                                        >
                                        <div style="width: 58%">
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    v-model="sendmail"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="consultant_id < 1" class="mt-4">
                                        <button
                                            class="btn btn-primary"
                                            @click.prevent="consultant_create"
                                        >
                                            Save New User
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!-- Labels Section -->
                        <div v-if="consultant_id > 0" class="col-6">
                            <div class="form-inline col-12 text-start">
                                <span class="col-12 px-0 mx-0 pt-2 pb-4"
                                    >Labels</span
                                ><br />
                                <ConsultantLabelPicker
                                    :consultant-id="consultant_id"
                                    :labels="labels"
                                    @add="saveaddlabel"
                                    @remove="removelabel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Features Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="features"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Require Two-factor login</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="i_2fa"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'i_2fa',
                                                        i_2fa,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Require Two-factor Email
                                        login</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="i_2fa_email"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'i_user',
                                                        consultant_id,
                                                        'i_2fa_email',
                                                        i_2fa_email,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Can use GDQ Short</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="gdq_short"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'gdq_short',
                                                        gdq_short,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Can use OSC</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="osc"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'osc',
                                                        osc,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Can use Aggregated Short</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="aggregated_reports"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'aggregated_reports',
                                                        aggregated_reports,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Can use Aggregated Full</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="aggregated_full"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'aggregated_full',
                                                        aggregated_full,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Allow GDQ Demographics</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="allow_demographics"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'allow_demographics',
                                                        allow_demographics,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Can pay by invoice</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="can_pay_invoice"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'can_pay_invoice',
                                                        can_pay_invoice,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3 d-flex align-items-center">
                                    <label
                                        class="col-form-label"
                                        style="width: 42%; flex-shrink: 0"
                                        >Show consultant on GDQ web</label
                                    >
                                    <div style="width: 58%">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="visible_web"
                                                :true-value="1"
                                                :false-value="0"
                                                @change="
                                                    savefield(
                                                        'g_profile',
                                                        consultant_id,
                                                        'visible_web',
                                                        visible_web,
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Surveys Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="surveys"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link active"
                                    data-bs-toggle="tab"
                                    data-bs-target="#ongoing"
                                    type="button"
                                >
                                    <fa-icon
                                        name="rocket"
                                        class="me-1"
                                    />Ongoing
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#drafts"
                                    type="button"
                                >
                                    <fa-icon name="pen" class="me-1" />Drafts
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#upcoming"
                                    type="button"
                                >
                                    <fa-icon
                                        name="clock"
                                        class="me-1"
                                    />Upcoming
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#finished"
                                    type="button"
                                >
                                    <fa-icon
                                        name="check"
                                        class="me-1"
                                    />Completed
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#deleted"
                                    type="button"
                                >
                                    <fa-icon
                                        name="trash-alt"
                                        class="me-1"
                                    />Deleted
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content mt-3">
                            <div class="tab-pane fade show active" id="ongoing">
                                <ConsultantSurveys surveytype="ongoing" />
                            </div>
                            <div class="tab-pane fade" id="drafts">
                                <ConsultantSurveys surveytype="drafts" />
                            </div>
                            <div class="tab-pane fade" id="upcoming">
                                <ConsultantSurveys surveytype="upcoming" />
                            </div>
                            <div class="tab-pane fade" id="finished">
                                <ConsultantSurveys surveytype="finished" />
                            </div>
                            <div class="tab-pane fade" id="deleted">
                                <ConsultantSurveys surveytype="deleted" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Invoices Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="invoices"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="field in invoicefields"
                                            :key="field.key"
                                        >
                                            {{ field.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="invoiceloading">
                                    <tr>
                                        <td
                                            :colspan="invoicefields.length"
                                            class="text-center"
                                        >
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span class="visually-hidden"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr
                                        v-for="inv in invoices"
                                        :key="inv.id"
                                    >
                                        <td
                                            v-for="field in invoicefields"
                                            :key="`${inv.id}-${field.key}`"
                                        >
                                            {{ inv[field.key] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Certifications Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="certifications"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="field in certificationfields"
                                            :key="field.key"
                                        >
                                            {{ field.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="loading">
                                    <tr>
                                        <td
                                            :colspan="
                                                certificationfields.length
                                            "
                                            class="text-center"
                                        >
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span class="visually-hidden"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr
                                        v-for="cert in certifications"
                                        :key="cert.id"
                                    >
                                        <td
                                            v-for="field in certificationfields"
                                            :key="`${cert.id}-${field.key}`"
                                        >
                                            {{ cert[field.key] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Virtual Badges Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="virtualbadges"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="mb-3 text-start">
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click.prevent="virtualbadge_issue"
                                :disabled="vbissuing > 0"
                            >
                                <span
                                    v-if="vbissuing > 0"
                                    class="spinner-border spinner-border-sm me-2"
                                    role="status"
                                >
                                    <span class="visually-hidden"
                                        >Issuing...</span
                                    >
                                </span>
                                Issue badge
                            </button>
                        </div>
                        <div
                            v-if="vbmessage != ''"
                            class="alert mb-3 text-start"
                            :class="
                                vbsuccess == 1
                                    ? 'alert-success'
                                    : 'alert-danger'
                            "
                            role="alert"
                        >
                            {{ vbmessage }}
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="field in virtualbadgefields"
                                            :key="field.key"
                                        >
                                            {{ field.label }}
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody v-if="vbloading">
                                    <tr>
                                        <td
                                            :colspan="
                                                virtualbadgefields.length +
                                                1
                                            "
                                            class="text-center"
                                        >
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span class="visually-hidden"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="virtualbadges.length == 0">
                                    <tr>
                                        <td
                                            :colspan="
                                                virtualbadgefields.length +
                                                1
                                            "
                                        >
                                            No virtual badges issued.
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr
                                        v-for="vb in virtualbadges"
                                        :key="vb.id"
                                    >
                                        <td
                                            v-for="field in virtualbadgefields"
                                            :key="`${vb.id}-${field.key}`"
                                        >
                                            <a
                                                v-if="
                                                    field.key ==
                                                    'validation_page_url'
                                                "
                                                :href="vb[field.key]"
                                                target="_blank"
                                                rel="noopener"
                                                >Open</a
                                            >
                                            <template v-else>
                                                {{ vb[field.key] }}
                                            </template>
                                        </td>
                                        <td>
                                            <button
                                                v-if="
                                                    vb.email_status !=
                                                    'revoked'
                                                "
                                                class="btn btn-sm btn-outline-danger"
                                                type="button"
                                                @click.prevent="
                                                    virtualbadge_revoke_confirm(
                                                        vb.id
                                                    )
                                                "
                                                :disabled="vbrevoking > 0"
                                            >
                                                Revoke
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Revoke Virtual Badge Modal -->
            <div
                class="modal fade"
                :class="{
                    show: vbrevokeshow,
                    'd-block': vbrevokeshow,
                }"
                tabindex="-1"
                :style="{ display: vbrevokeshow ? 'block' : 'none' }"
                @click.self="virtualbadge_revoke_cancel"
            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Revoke virtual badge?
                            </h5>
                            <button
                                type="button"
                                class="btn-close"
                                @click="virtualbadge_revoke_cancel"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body">
                            <p>
                                Do you really want to revoke this virtual
                                badge? The badge can no longer be validated or
                                distributed. This is final and cannot be
                                undone.
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click="virtualbadge_revoke_cancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-danger"
                                @click="virtualbadge_revoke"
                                :disabled="vbrevoking > 0"
                            >
                                <span
                                    v-if="vbrevoking > 0"
                                    class="spinner-border spinner-border-sm me-2"
                                    role="status"
                                >
                                    <span class="visually-hidden"
                                        >Revoking...</span
                                    >
                                </span>
                                Yes, revoke
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="vbrevokeshow"
                class="modal-backdrop fade show"
            ></div>

            <!-- Events Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="events"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="field in eventfields"
                                            :key="field.key"
                                        >
                                            {{ field.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="eventsloading">
                                    <tr>
                                        <td
                                            :colspan="eventfields.length"
                                            class="text-center"
                                        >
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span class="visually-hidden"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr
                                        v-for="ev in events"
                                        :key="ev.id"
                                    >
                                        <td
                                            v-for="field in eventfields"
                                            :key="`${ev.id}-${field.key}`"
                                        >
                                            {{ ev[field.key] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Courses Tab -->
            <div
                v-if="consultant_id > 0"
                class="tab-pane fade"
                id="courses"
                role="tabpanel"
            >
                <div class="card border-0">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th
                                            v-for="field in coursefields"
                                            :key="field.key"
                                        >
                                            {{ field.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="coursesloading">
                                    <tr>
                                        <td
                                            :colspan="coursefields.length"
                                            class="text-center"
                                        >
                                            <div
                                                class="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span class="visually-hidden"
                                                    >Loading...</span
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr
                                        v-for="crs in courses"
                                        :key="crs.id"
                                    >
                                        <td
                                            v-for="field in coursefields"
                                            :key="`${crs.id}-${field.key}`"
                                        >
                                            {{ crs[field.key] }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ConsultantSurveys from "./ConsultantSurveys";
import ConsultantLabelPicker from "./Consultant/ConsultantLabelPicker.vue";
import Datetime from "./CustomControls/Datetime.vue";
import axios from "axios";
import { config } from "../../config";
const base_url = config.base_url;
const api_token = config.api_token;

const notimportedfields = [
    { key: "select", label: "", sortable: false },
    { key: "group_name", label: "Not Imported Groups", sortable: false },
    { key: "actions", label: "", sortable: false, tdClass: "col-1" },
];

export default {
    components: {
        ConsultantSurveys,
        ConsultantLabelPicker,
        Datetime,
    },
    name: "Consultant",
    created() {
        this.loading = true;
        this.get_recertification_params();
        this.consultantgroups_get();
        this.countries_get();
        this.partners_get();
        this.tots_get();
        this.companies_get();
        this.consultantstatuses_get();
        this.enterprises_get();
        this.invoices_get();
        this.consultant_get();
        this.certifications_get();
        this.virtualbadges_get();
        this.consultantusergroups_get();
        this.events_get();
        this.courses_get();
    },
    data: function () {
        return {
            gui_loaded: false,
            formok: false,
            mailok: null,
            family_name: "",
            family_name_valid: null,
            first_name: "",
            first_name_valid: null,
            old_email: "",
            email: "",
            email_valid: null,
            prefix_title: null,
            company_name: null,
            address_1: null,
            address_2: null,
            zip_code: null,
            city: null,
            url: null,
            telephone: "",
            i_name: "",
            i_name_valid: null,
            i_password: "",
            i_usergroups: [],
            invoices: [],
            invoiceloading: false,
            events: [],
            eventsloading: false,
            eventfields: [
                { key: "event_title", label: "Event" },
                { key: "reference", label: "Reference" },
                { key: "status", label: "Status" },
                { key: "seats", label: "Seats" },
                { key: "created_at", label: "Booked" },
            ],
            courses: [],
            coursesloading: false,
            coursefields: [
                { key: "course_name", label: "Course" },
                { key: "track", label: "Track" },
                { key: "status", label: "Status" },
                { key: "steps", label: "Steps" },
                { key: "enrolled_at", label: "Enrolled" },
            ],
            invoicefields: [
                { key: "invoice_number", label: "Invoice #" },
                { key: "invoice_date", label: "Date" },
                { key: "survey_name", label: "Survey" },
                { key: "invoice_amount", label: "Amount" },
                { key: "invoice_paid_amount", label: "Paid" },
                { key: "invoice_balance", label: "Balance" },
            ],
            certificate_number: "",
            certification_date: null,
            gdq_short: 0,
            i_2fa: 0,
            i_2fa_email: 0,
            osc: 0,
            aggregated_reports: 0,
            aggregated_full: 0,
            spotify: 0,
            can_pay_invoice: 1,
            country_id: 0,
            country_id_valid: null,
            countries: [],
            company_id: 0,
            company_id_valid: null,
            companies: [],
            var_number: "",
            consultantgroup_id: 0,
            enterprise_id: 0,
            enterprises: [],
            partner_id: 0,
            partner_id_valid: null,
            partners: [],
            certified_by: null,
            certified_by_valid: null,
            tots: [],
            consultantstatus_id: 0,
            consultantstatuses: [],
            labels: [],
            loading: false,
            saving: false,
            settingpassword: false,
            newpassword: "",
            updatingusergroups: false,
            sendmail: false,
            notimported: [],
            notimportedfields: notimportedfields,
            importinggroup: 0,
            allow_demographics: 0,
            anonymize_survey_on_close: 0,
            vat_number: "",
            visible_web: 0,
            newsletter: 0,
            general_emails: 1,
            priority_emails: 1,
            mailsent: 0,
            last_login: null,
            lastlogin_months: 0,
            gdq_recertification_months: 1000,
            gdq_recertification: false,
            certificationfields: [],
            certifications: [],
            virtualbadgefields: [],
            virtualbadges: [],
            vbloading: 0,
            vbissuing: 0,
            vbrevoking: 0,
            vbrevokeshow: false,
            vbrevokeid: 0,
            vbmessage: "",
            vbsuccess: 0,
            consultantgroups: [],
        };
    },
    computed: {
        anon: function () {
            return this.$store.state.anon;
        },
        consultant_id: {
            get() {
                return this.$store.state.currentconsultant_id;
            },
        },
        usergroups: {
            get() {
                return this.$store.state.usergroups;
            },
        },
        emailinvalidfeedback() {
            if (this.email == "") {
                return "E-mail is invalid";
            }
            // eslint-disable-next-line
            if (!this.parse_email(this.email)) {
                return "Incorrect e-mail format";
            }
            return "E-mail already exists";
        },
        current_id() {
            return this.consultant_id;
        },
    },
    methods: {
        invoices_get() {
            if (this.consultant_id <= 0) return;
            this.invoiceloading = true;
            this.$store
                .dispatch("invoices_fetch", {
                    start: 1,
                    limit: 1000,
                    orderby: "invoice_date",
                    order: "DESC",
                    filter: {
                        "g_consultantinvoices.user_id": {
                            operator: "=",
                            value: this.consultant_id,
                        },
                    },
                    company_id: 0,
                    partner_id: 0,
                    surveytype_id: 0,
                })
                .then((resp) => {
                    this.invoices = Array.isArray(resp.data?.result)
                        ? resp.data.result
                        : [];
                    this.invoiceloading = false;
                });
        },
        certifications_get() {
            const filter = {
                user_id: {
                    operator: "=",
                    value: this.consultant_id,
                },
            };
            this.$store
                .dispatch("records_readlist", {
                    table_name: "g_certifications",
                    filter,
                })
                .then((resp) => {
                    this.certificationfields = resp.data.columns.map((r) => ({
                        key: r.field_name,
                        label: r.list_caption,
                    }));
                    this.certifications = resp.data.result;
                });
        },
        virtualbadges_get() {
            if (this.consultant_id <= 0) return;
            const filter = {
                user_id: {
                    operator: "=",
                    value: this.consultant_id,
                },
            };
            this.vbloading = 1;
            this.$store
                .dispatch("records_readlist", {
                    table_name: "g_virtualbadges",
                    filter,
                })
                .then((resp) => {
                    this.vbloading = 0;
                    this.virtualbadgefields = resp.data.columns.map((r) => ({
                        key: r.field_name,
                        label: r.list_caption,
                    }));
                    this.virtualbadges = resp.data.result;
                });
        },
        virtualbadge_issue() {
            if (this.consultant_id <= 0) return;
            axios.defaults.headers.common["Authorization"] =
                "Bearer:" + api_token;
            this.vbissuing = 1;
            this.vbmessage = "";
            axios
                .post(
                    base_url + "/gdq_virtualbadge_issue",
                    JSON.stringify({ user_id: this.consultant_id }),
                    {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        },
                    },
                )
                .then((resp) => {
                    this.vbissuing = 0;
                    this.vbsuccess = 1;
                    this.vbmessage = resp.data.existing
                        ? "Badge already issued for this consultant."
                        : "Badge issued.";
                    this.virtualbadges_get();
                })
                .catch((err) => {
                    this.vbissuing = 0;
                    this.vbsuccess = 0;
                    this.vbmessage =
                        "Issue failed: " +
                        (err.response && err.response.data
                            ? err.response.data.error
                            : err.message);
                });
        },
        virtualbadge_revoke_confirm(id) {
            this.vbrevokeid = id;
            this.vbrevokeshow = true;
        },
        virtualbadge_revoke() {
            axios.defaults.headers.common["Authorization"] =
                "Bearer:" + api_token;
            this.vbrevoking = 1;
            this.vbmessage = "";
            axios
                .post(
                    base_url + "/gdq_virtualbadge_revoke",
                    JSON.stringify({ id: this.vbrevokeid }),
                    {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        },
                    },
                )
                .then((resp) => {
                    this.vbrevoking = 0;
                    this.vbrevokeshow = false;
                    this.vbrevokeid = 0;
                    this.vbsuccess = 1;
                    this.vbmessage = resp.data.existing
                        ? "Badge already revoked."
                        : "Badge revoked.";
                    this.virtualbadges_get();
                })
                .catch((err) => {
                    this.vbrevoking = 0;
                    this.vbrevokeshow = false;
                    this.vbrevokeid = 0;
                    this.vbsuccess = 0;
                    this.vbmessage =
                        "Revoke failed: " +
                        (err.response && err.response.data
                            ? err.response.data.error
                            : err.message);
                });
        },
        virtualbadge_revoke_cancel() {
            this.vbrevokeid = 0;
            this.vbrevokeshow = false;
        },
        events_get() {
            if (this.consultant_id <= 0) return;
            this.eventsloading = true;
            this.$store
                .dispatch("bookings_list", {
                    gdq_user_id: this.consultant_id,
                    start: 1,
                    limit: 1000,
                })
                .then((resp) => {
                    this.events = Array.isArray(resp.data?.result)
                        ? resp.data.result
                        : [];
                    this.eventsloading = false;
                });
        },
        courses_get() {
            if (this.consultant_id <= 0) return;
            this.coursesloading = true;
            this.$store
                .dispatch("learninghub_enrolments_by_user_fetch", {
                    user_id: this.consultant_id,
                })
                .then((resp) => {
                    this.courses = Array.isArray(resp.data?.result)
                        ? resp.data.result.map((r) => ({
                              ...r,
                              steps: r.steps_done + "/" + r.steps_total,
                          }))
                        : [];
                    this.coursesloading = false;
                });
        },
        async get_recertification_params() {
            await this.$store
                .dispatch("syspref_fetch", {
                    key: "gdq_recertification_months",
                })
                .then((resp) => {
                    this.gdq_recertification_months = resp.data.value;
                });
        },
        sendpasswordlink() {
            const filter = {
                email: {
                    operator: "=",
                    value: this.email,
                },
            };
            this.$store
                .dispatch("forgotpassword", { filter: filter })
                .then(() => {
                    this.mailsent = 1;
                });
        },
        sendwelcomeemail() {
            this.$store
                .dispatch("profile_send_welcome_email", {
                    user_id: this.consultant_id,
                })
                .then(() => {
                    this.mailsent = 2;
                });
        },

        async generate_certificate_number() {
            await this.$store
                .dispatch("profile_generate_certificate_number", {
                    id: this.consultant_id,
                })
                .then((resp) => {
                    this.certificate_number = resp.data.certificate_number;
                });
        },
        parse_email(email) {
            if (email !== undefined) {
                return true;
            }
            // eslint-disable-next-line
            const pattern =
                /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(email.toLowerCase());
        },
        group_import(id) {
            this.importinggroup = id;
            axios.defaults.headers.common["Authorization"] =
                "Bearer:" + api_token;
            return new Promise((resolve) => {
                axios
                    .get(
                        base_url +
                            "/gdq_migration_import_group/?consultant_id=" +
                            this.consultant_id +
                            "&old_group_id=" +
                            id,
                    )
                    .then((resp) => {
                        this.importinggroup = 0;
                        this.consultant_get();
                        this.notimported_get();
                        resolve(resp);
                    });
            });
        },
        notimported_get() {
            axios.defaults.headers.common["Authorization"] =
                "Bearer:" + api_token;
            return new Promise((resolve) => {
                axios
                    .get(
                        base_url +
                            "/gdq_migration_consultant_notimported_get/?email=" +
                            this.email,
                    )
                    .then((resp) => {
                        if (resp.data.groups) {
                            this.notimported = resp.data.groups.map((a) => {
                                return {
                                    id: a.id,
                                    group_name: a.group_name,
                                    import: 1,
                                    old_id: a.old_id,
                                };
                            });
                        }
                        resolve(resp);
                    });
            });
        },
        savepassword() {
            this.savefield(
                "i_user",
                this.consultant_id,
                "i_password",
                this.newpassword,
            );
            this.settingpassword = false;
            this.newpassword = "";
        },
        setpassword(setting) {
            this.settingpassword = setting;
        },
        checkemail() {
            this.formok = true;
            this.mailok = true;
            this.email_valid = true;
            if (this.email == "") {
                this.email_valid = false;
                this.formok = false;
                this.mailok = false;
            }

            if (!this.parse_email(this.email)) {
                this.email_valid = false;
                this.formok = false;
                this.mailok = false;
            }
            if (this.email != this.old_email) {
                //----------------------
                // Check if email exists
                //----------------------
                if (this.mailok) {
                    var filteremail = this.email;
                    var filter = {
                        id: {
                            operator: "<>",
                            value: this.consultant_id,
                        },
                        email: {
                            operator: "=",
                            value: filteremail,
                        },
                    };
                    this.$store
                        .dispatch("user_email_check", {
                            filter: filter,
                        })
                        .then((resp) => {
                            if (resp.data.total > 0) {
                                this.email_valid = false;
                                this.formok = false;
                                return this.formok;
                            }
                        });
                } else {
                    return this.formok;
                }
            } else {
                return this.formok;
            }
        },
        checkform() {
            if (this.gui_loaded != true) {
                return true;
            }
            this.formok = true;
            this.mailok = true;
            this.family_name_valid = true;
            this.first_name_valid = true;
            this.email_valid = true;
            if (this.family_name == "") {
                this.family_name_valid = false;
                this.formok = false;
            }
            if (this.first_name == "") {
                this.first_name_valid = false;
                this.formok = false;
            }
            if (this.email == "") {
                this.email_valid = false;
                this.formok = false;
                this.mailok = false;
            } else {
                if (!this.parse_email(this.email)) {
                    this.email_valid = false;
                    this.formok = false;
                    this.mailok = false;
                }
            }
            if (this.email != this.old_email) {
                //----------------------
                // Check if email exists
                //----------------------
                if (this.mailok) {
                    var filteremail = this.email;
                    var filter = {
                        id: {
                            operator: "<>",
                            value: this.consultant_id,
                        },
                        email: {
                            operator: "=",
                            value: filteremail,
                        },
                    };
                    this.$store
                        .dispatch("user_email_check", {
                            filter: filter,
                        })
                        .then((resp) => {
                            if (resp.data.total > 0) {
                                this.email_valid = false;
                                this.formok = false;
                                return this.formok;
                            }
                        });
                } else {
                    return this.formok;
                }
            } else {
                return this.formok;
            }
            return this.formok;
        },
        saveusergroups: function () {
            if (
                this.consultant_id <= 0 ||
                this.loading == true ||
                this.updatingusergroups == true
            ) {
                return;
            }
            this.updatingusergroups = true;
            this.$store
                .dispatch("consultantusergroups_save", {
                    consultant_id: this.consultant_id,
                    i_usergroups: this.i_usergroups,
                })
                .then((resp) => {
                    this.updatingusergroups = false;
                    return resp;
                });
        },
        consultant_create: function () {
            var check = this.checkform();
            if (check) {
                this.saving = true;

                // Capture all form values BEFORE entering Promise chain to avoid 'this' context issues
                const profileData = {
                    prefix_title: this.prefix_title,
                    company_name: this.company_name,
                    address_1: this.address_1,
                    address_2: this.address_2,
                    zip_code: this.zip_code,
                    city: this.city,
                    url: this.url,
                    telephone: this.telephone,
                    certificate_number: this.certificate_number,
                    country_id: this.country_id,
                    consultantstatus_id: this.consultantstatus_id,
                    company_id: this.company_id,
                    vat_number: this.vat_number,
                    consultantgroup_id: this.consultantgroup_id,
                    partner_id: this.partner_id,
                    enterprise_id: this.enterprise_id,
                    certified_by: this.certified_by,
                    certification_date: this.format_date(
                        this.certification_date,
                    ),
                    gdq_short: this.gdq_short,
                    osc: this.osc,
                    aggregated_reports: this.aggregated_reports,
                    aggregated_full: this.aggregated_full,
                    spotify: this.spotify,
                    can_pay_invoice: this.can_pay_invoice,
                    allow_demographics: this.allow_demographics,
                    anonymize_survey_on_close: this.anonymize_survey_on_close,
                    visible_web: this.visible_web,
                    newsletter: this.newsletter,
                    general_emails: this.general_emails,
                    priority_emails: this.priority_emails,
                    sendmail: this.sendmail,
                };

                const userGroupsData = [...this.i_usergroups];

                var i_user = {
                    family_name: this.family_name,
                    first_name: this.first_name,
                    email: this.email,
                    i_email: this.email,
                    i_name: this.i_name,
                    i_password: this.newpassword,
                    i_2fa: this.i_2fa,
                    i_2fa_email: this.i_2fa_email,
                };
                this.$store
                    .dispatch("user_create", { i_user: i_user })
                    .then((resp) => {
                        var user_id = resp.data.id;
                        // Create profile first, then set current consultant to avoid triggering reads
                        this.$store
                            .dispatch("profile_create", {
                                user_id: user_id,
                                profile: profileData,
                            })
                            .then(() => {
                                //-----------------------------
                                // Save i_usergroup stuffs
                                //-----------------------------
                                this.mailok = null;
                                this.updatingusergroups = true;
                                this.$store
                                    .dispatch("consultantusergroups_save", {
                                        consultant_id: user_id,
                                        i_usergroups: userGroupsData,
                                    })
                                    .then(() => {
                                        this.updatingusergroups = false;
                                        // Now set the current consultant and fetch all data
                                        this.$store
                                            .dispatch("consultant_setcurrent", {
                                                consultant_id: user_id,
                                            })
                                            .then(() => {
                                                this.consultant_get();
                                                this.saving = false;
                                            });
                                    });
                            });
                    });
            } else {
                alert("Error saving");
            }
        },
        savefield(tablename, id, fieldname, value) {
            if (!this.loading) {
                if (fieldname === "certification_date") {
                    value = this.certification_date;
                }
                if (fieldname.indexOf("_date") != -1) {
                    value = this.format_date(value);
                }
                if (id > 0) {
                    if (this.checkform()) {
                        var record = {
                            id: id,
                            [fieldname]: value,
                        };
                        this.$store
                            .dispatch("field_save", {
                                tablename: tablename,
                                record: record,
                            })
                            .then(() => {
                                if (
                                    tablename == "i_user" &&
                                    fieldname == "i_2fa" &&
                                    value == 0
                                ) {
                                    this.$store.dispatch("field_save", {
                                        tablename: tablename,
                                        record: { id: id, i_2fa_secret: "" },
                                    });
                                }
                                this.$store.dispatch("consultantchanged_set", {
                                    consultant_id: this.consultant_id,
                                });
                            });
                    }
                }
            }
        },
        tots_get() {
            this.$store.dispatch("tots_fetch").then((resp) => {
                this.tots = [];
                this.tots.push({
                    value: 0,
                    text: "",
                });
                for (var i = 0; i < resp.data.result.length; i++) {
                    var totoption = {
                        value: resp.data.result[i].id,
                        text:
                            resp.data.result[i].name +
                            " - " +
                            resp.data.result[i].email,
                    };
                    this.tots.push(totoption);
                }
            });
        },
        countries_get() {
            this.$store.dispatch("countries_fetch").then((resp) => {
                this.countries = [];
                for (var i = 0; i < resp.data.result.length; i++) {
                    var countryoption = {
                        value: resp.data.result[i].id,
                        text: resp.data.result[i].country_name,
                    };
                    this.countries.push(countryoption);
                }
            });
        },
        companies_get() {
            this.$store
                .dispatch("companies_fetch", {
                    filter: "",
                    start: 1,
                    limit: 999999,
                    orderby: "company_name",
                    order: "ASC",
                })
                .then((resp) => {
                    this.companies = [];
                    this.companies.push({
                        value: 0,
                        text: "",
                    });
                    for (var i = 0; i < resp.data.result.length; i++) {
                        var companyoption = {
                            value: resp.data.result[i].id,
                            text: resp.data.result[i].company_name,
                        };
                        this.companies.push(companyoption);
                    }
                });
        },
        consultantgroups_get() {
            this.$store
                .dispatch("records_readlist", {
                    table_name: "g_consultantgroups",
                })
                .then((resp) => {
                    let consultantgroups = resp.data.result.map((r) => ({
                        value: r.id,
                        text: r.consultantgroup_name,
                    }));
                    consultantgroups.unshift({
                        value: 0,
                        text: "- no consultant group -",
                    });
                    this.consultantgroups = consultantgroups;
                });
        },
        partners_get() {
            this.$store
                .dispatch("partners_fetch", {
                    filter: "",
                    start: 1,
                    limit: 999999,
                    orderby: "partner_name",
                    order: "ASC",
                })
                .then((resp) => {
                    this.partners = [];
                    this.partners.push({
                        value: 0,
                        text: "",
                    });
                    for (var i = 0; i < resp.data.result.length; i++) {
                        var partneroption = {
                            value: resp.data.result[i].id,
                            text: resp.data.result[i].partner_name,
                        };
                        this.partners.push(partneroption);
                    }
                });
        },
        enterprises_get() {
            this.$store.dispatch("enterprises_fetch").then((resp) => {
                const enterprises = (
                    Array.isArray(resp.data?.result)
                        ? resp.data.result
                        : []
                ).map((e) => ({
                    value: e.id,
                    text: e.enterprise_name,
                }));
                enterprises.unshift({ value: 0, text: "-" });
                this.enterprises = enterprises;
            });
        },

        consultantstatuses_get() {
            this.$store
                .dispatch("consultantstatuses_fetch", {
                    filter: {
                        consultantstatus_name: {
                            operator: "<>",
                            value: "",
                        },
                    },
                    start: 1,
                    limit: 999999,
                    orderby: "id",
                    order: "ASC",
                })
                .then((resp) => {
                    this.consultantstatuses = [];
                    for (var i = 0; i < resp.data.result.length; i++) {
                        var consultantstatus = {
                            value: resp.data.result[i].id,
                            text: resp.data.result[i].consultantstatus_name,
                        };
                        this.consultantstatuses.push(consultantstatus);
                    }
                });
        },
        consultantusergroups_get() {
            this.$store
                .dispatch("consultantusergroups_fetch", {
                    consultant_id: this.consultant_id,
                })
                .then((resp) => {
                    this.i_usergroups = resp.data.groups.map(g => parseInt(g, 10));
                })
                .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error("Failed to fetch consultant user groups:", err);
                });
        },
        async consultant_get() {
            this.loading = false;
            this.family_name = "";
            this.first_name = "";
            this.email = "";
            this.old_email = "";
            this.telephone = "";
            this.prefix_title = "";
            this.company_name = "";
            this.address_1 = "";
            this.address_2 = "";
            this.zip_code = "";
            this.city = "";
            this.url = "";
            this.i_name = "";
            this.i_password = "";
            this.country_id = 0;
            this.consultantstatus_id = 0;
            this.company_id = 0;
            this.company_name = "";
            this.vat_number = "";
            this.consultantgroup_id = 0;
            this.enterprise_id = 0;
            this.partner_id = 0;
            this.certified_by = 0;
            this.certificate_number = "";
            this.certification_date = null;
            this.gdq_short = 0;
            this.osc = 0;
            this.aggregated_reports = 0;
            this.aggregated_full = 0;
            this.spotify = 0;
            this.can_pay_invoice = 1;
            this.visible_web = 0;
            this.newsletter = 0;
            this.general_emails = 1;
            this.priority_emails = 1;
            this.allow_demographics = 0;
            this.anonymize_survey_on_close = 0;
            this.lastlogin = null;
            this.i_2fa = 0;
            this.i_2fa_email = 0;
            this.labels = [];
            this.loading = true;
            if (this.consultant_id > 0) {
                await this.$store
                    .dispatch("consultant_fetch", {
                        consultant_id: this.consultant_id,
                    })
                    .then((resp) => {
                        this.gdq_recertification = false;
                        this.lastlogin_months = 0;
                        if (resp.data.last_login !== null) {
                            const d1 = new Date(
                                resp.data.last_login.replace(" ", "T"),
                            );
                            const d2 = new Date();
                            let months = 0;
                            months = (d2.getFullYear() - d1.getFullYear()) * 12;
                            months -= d1.getMonth() + 1;
                            months += d2.getMonth() + 1;
                            this.lastlogin_months = months;
                        } else {
                            if (resp.data.certification_date !== null) {
                                const d1 = new Date(
                                    resp.data.certification_date.replace(
                                        " ",
                                        "T",
                                    ),
                                );
                                const d2 = new Date();
                                let months = 0;
                                months =
                                    (d2.getFullYear() - d1.getFullYear()) * 12;
                                months -= d1.getMonth() + 1;
                                months += d2.getMonth() + 1;
                                this.lastlogin_months = months;
                            }
                        }
                        // console.log(`Last login: ${this.lastlogin_months}, ${this.gdq_recertification_months || 1000}`)
                        if (
                            parseInt(this.lastlogin_months) >
                            parseInt(this.gdq_recertification_months)
                        ) {
                            this.gdq_recertification = true;
                        }
                        this.first_name = resp.data.first_name;
                        this.family_name = resp.data.family_name;
                        this.email = resp.data.email;
                        this.old_email = resp.data.email;
                        this.telephone = resp.data.telephone;
                        this.prefix_title = resp.data.prefix_title;
                        this.company_name = resp.data.company_name;
                        this.address_1 = resp.data.address_1;
                        this.address_2 = resp.data.address_2;
                        this.zip_code = resp.data.zip_code;
                        this.city = resp.data.city;
                        this.url = resp.data.url;
                        this.i_name = resp.data.i_name;
                        this.country_id = resp.data.country_id;
                        this.consultantstatus_id =
                            resp.data.consultantstatus_id;
                        this.company_id = resp.data.company_id;
                        this.company_name = resp.data.company_name;
                        this.vat_number = resp.data.vat_number;
                        this.consultantgroup_id = resp.data.consultantgroup_id;
                        this.partner_id = resp.data.partner_id;
                        this.enterprise_id = resp.data.enterprise_id || 0;
                        this.certified_by = resp.data.certified_by;
                        this.certificate_number = resp.data.certificate_number;
                        this.certification_date = resp.data.certification_date;
                        this.gdq_short = resp.data.gdq_short;
                        this.osc = resp.data.osc;
                        this.aggregated_reports = resp.data.aggregated_reports;
                        this.aggregated_full = resp.data.aggregated_full;
                        this.spotify = resp.data.spotify;
                        this.can_pay_invoice = resp.data.can_pay_invoice;
                        this.visible_web = resp.data.visible_web;
                        this.newsletter = resp.data.newsletter;
                        this.general_emails = resp.data.general_emails;
                        this.priority_emails = resp.data.priority_emails;
                        this.allow_demographics = resp.data.allow_demographics;
                        this.anonymize_survey_on_close =
                            resp.data.anonymize_survey_on_close;
                        this.i_2fa = resp.data.i_2fa;
                        this.i_2fa_email = resp.data.i_2fa_email;
                        this.last_login = resp.data.last_login;
                        this.labels = resp.data.labels;
                        this.checkform();
                        this.$store
                            .dispatch("consultantusergroups_fetch", {
                                consultant_id: this.consultant_id,
                            })
                            .then((resp) => {
                                this.i_usergroups = resp.data.groups.map(g => parseInt(g, 10));
                                this.loading = false;
                                this.gui_loaded = true;
                                this.notimported_get();
                            });
                    });
            }
        },
        backtolist() {
            this.$store.dispatch("consultant_setcurrent", { consultant_id: 0 });
        },
        conslabels_get() {
            this.$store
                .dispatch("consultant_fetch", {
                    consultant_id: this.consultant_id,
                })
                .then((resp) => {
                    this.labels = resp.data.labels;
                });
        },
        saveaddlabel(labeltext) {
            if (labeltext != "") {
                var savelabel = {
                    consultant_id: this.consultant_id,
                    label: labeltext,
                };
                this.$store
                    .dispatch("consultantlabel_add", { label: savelabel })
                    .then(() => {
                        this.conslabels_get();
                        this.$store.dispatch("consultantlabelchanged_set", {
                            consultant_id: this.consultant_id,
                        });
                    });
            }
        },
        removelabel(consultantlabel_id) {
            this.$store
                .dispatch("consultantlabel_delete", { id: consultantlabel_id })
                .then(() => {
                    this.conslabels_get();
                    this.$store.dispatch("consultantlabelchanged_set", {
                        consultant_id: this.consultant_id,
                    });
                });
        },
        format_date(date) {
            if (date === null || date === undefined || date === "") return "";
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (isNaN(year)) {
                return "";
            }
            if (Number.isNaN(month)) {
                return "";
            }
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");
        },
        format_time(date) {
            if (date.length == 5) {
                return date;
            }
            var d = new Date(date);
            var h = d.getHours();
            var m = d.getMinutes();
            var hour = (h > 9 ? "" : "0") + h;
            var minute = (m > 9 ? "" : "0") + m;
            var thistime = hour + ":" + minute;
            return thistime;
        },
    },
};
</script>
